/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Creating_Account_ButtonInputs */



/**
* | output |
* | --- |
* | "Creating Account..." |
*
* @param {Login_Creating_Account_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_creating_account_button = /** @type {((inputs?: Login_Creating_Account_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Creating_Account_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création du compte...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konto wird erstellt...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione account...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание учетной записи...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando cuenta...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建账户...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アカウントを作成しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाता बनाया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criando conta...")
	return /** @type {LocalizedString} */ ("Creating Account...")
});